<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.HelpsWith"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | method: 'getSectionHeaderTextColor' : section)
  "
  class="section-header-general section-header-helps-with">
  {{ menu | method: 'getTypeColumnTitle' : colVm }}
</div>
